import kebabCase from './kebabCase';

export default (prefix, label) => `${prefix}--${kebabCase(label)}`;
